import React from 'react';
import { SwitchOffIcon, SwitchOnIcon } from 'assets/icons';
import { useMutation } from '@apollo/client';
import {
  ACTIVATE_RATE_PLAN,
  DEACTIVATE_RATE_PLAN
} from 'graphql/service';
import { Container } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const Slider = ({
  ratePlanId,
  checked,
  setRatePlans,
  left
}) => {

  const [activateRatePlan] = useMutation(ACTIVATE_RATE_PLAN,
    {
      onCompleted: (data) => {
        setRatePlans(prevRatePlans => (
          prevRatePlans.map(ratePlan => {
            if(ratePlan.ratePlanId === ratePlanId) {
              return {...ratePlan, isActive: true};
            }
            return ratePlan;
          })
        ));
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  );

  const [deactivateRatePlan] = useMutation(DEACTIVATE_RATE_PLAN,
    {
      onCompleted: (data) => {
        setRatePlans(prevRatePlans => (
          prevRatePlans.map(ratePlan => {
            if(ratePlan.ratePlanId === ratePlanId) {
              return {...ratePlan, isActive: false};
            }
            return ratePlan;
          })
        ));
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  );

  const handleToggle = () => {
    if(checked) {
      deactivateRatePlan({
        variables: { 
          ratePlanId: ratePlanId
         }
      });
    } else {
      activateRatePlan({
        variables: { 
          input: {
            ratePlanId: ratePlanId
          }
        }
      });
    }
  }

  return (
    <Container
      left={left}
    >
      <div
        className={`switch ${checked? 'active': ''}`}
        onClick={handleToggle}
      >
        <div className={`switchSlider ${checked? 'active': ''}`}>
          {checked? <SwitchOnIcon />: <SwitchOffIcon />}
        </div>
      </div>
      <div className={`switchText ${checked? 'active': ''}`}>
        {checked? 'ON': 'OFF'}
      </div>
    </Container>
  );
}

export default Slider;
